import {isNumeric} from '../../../common/utils.js'
import NumberInput from '../../../common/components/Form/NumberInput.js'
import {showMultiboxModal} from '../../LabelConfig/Modals/MultiboxModal/index.js'
import {
  updateParcel,
  parcelSelector,
  isMultiboxSelector,
  onLabelPropertyValueChange,
  isLabelPropertyEnabledSelector,
} from '../../../data/labelInfos/index.js'
import {useSelector} from '../../../store.js'
import {FEDEX, FEDEX_360, UPS} from '../../../common/constants/ShipperNames.js'
import useLabelProperty, {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
  formatMetaClassName,
} from './useLabelProperty.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import className from '../../../common/className.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

export const DRY_ICE_WEIGHT = 'dry_ice_weight'
export const LABEL_PROPERTY_DRY_ICE_WEIGHT = `packages[0].${DRY_ICE_WEIGHT}`
function labelPropertiesFunc() {
  return [LABEL_PROPERTY_DRY_ICE_WEIGHT]
}
const VALID_SHIPPER_TYPES = [FEDEX, FEDEX_360, UPS]

export default function DryIceWeight({packagesIndex}) {
  packagesIndex = packagesIndex || 0
  const {
    labelInfoID,
    shipperType,
    onChange,
    isLabelEnableMode,
    isSummary,
    isPickMode,
  } = useLabelConfigContext()
  const propertySpecs = DryIceWeight.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  let {[DRY_ICE_WEIGHT]: dryIceWeight} = useSelector((state) =>
    parcelSelector(state, {labelInfoID, packagesIndex}),
  )
  const isMultibox = useSelector((state) =>
    isMultiboxSelector(state, {labelInfoID, shipperType}),
  )

  dryIceWeight = isNumeric(dryIceWeight) ? dryIceWeight : ''

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  const hide = !VALID_SHIPPER_TYPES.includes(shipperType)

  const disabled = isMultibox || (isLabelEnableMode && !isLabelPropertyEnabled)

  if (hide) {
    return null
  }

  const label = 'Dry Ice Weight'

  if (isSummary) {
    return label
  }

  if (isPickMode) {
    return <PickLabelProperty label={label} labelProperty={labelProperty} />
  }

  return (
    <li
      className={className`list__item--shipping-options ${formatMetaClassName(
        labelProperty,
      )} ${{
        'property-disabled': disabled,
      }}`}
    >
      <div className="wrap--edit-preset-form-input">
        <div className="flex">
          <label
            className="label--bold label--config__txt"
            htmlFor="dry-ice-weight"
          >
            {label} (oz)
          </label>
          {isMultibox && (
            <button
              className="btn btn--link margin-bottom-3 margin-left-3 fs-n0"
              type="button"
              onClick={() => showMultiboxModal(labelInfoID, shipperType)}
            >
              <em>(Multiple)</em>
            </button>
          )}
        </div>
        <NumberInput
          id="dry-ice-weight"
          value={isMultibox ? '' : dryIceWeight}
          disabled={disabled}
          onChange={(value) => {
            updateParcel(labelInfoID, packagesIndex, {[DRY_ICE_WEIGHT]: value})

            onLabelPropertyValueChange(labelInfoID, labelProperty)

            onChange()
          }}
        />
      </div>
      <EnableLabelProperty labelProperty={labelProperty} />
    </li>
  )
}

DryIceWeight.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
